module.exports = __webpack_public_path__ + "static/media/084-vision.9aa94057.svg";